/**************************************************
 * Nombre:       BotonTransparente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button} from "@mui/material";
import {FONDOCARD} from "../../../Constantes";

const BotonTransparente = ({titulo, Icono, click}) => {

    return (
        <Button
            onClick={() => click()}
            sx={{
                ...FONDOCARD,
                px: 0,
                fontSize: 12
            }}
            fullWidth
            startIcon={Icono && <Icono sx={{mt: 0}}/>}
        >
            {titulo}

        </Button>
    )

}
export default BotonTransparente